import logo from "./steam.png"
export default function SteamIcon(props) {    
  return <>
      <img src={logo} className={props.className} alt="steam logo" />
    </>
  
}
